import Typewriter from 'typewriter-effect/dist/core';

export function initTypewriterAnimations() {
  const typewriter = document.getElementById('typewriter');
  const strings = JSON.parse(typewriter.dataset.typewriterStrings);
  new Typewriter(typewriter, {
    strings: strings,
    autoStart: true,
    loop: true,
    delay: 50,
    deleteSpeed: 20,
  });
}